
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/220w-bifacial-solar-panel",
      function () {
        return require("private-next-pages/220w-bifacial-solar-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/220w-bifacial-solar-panel"])
      });
    }
  